mutation ignoreXeroSync($id: ID!) {
  ignoreXeroSync(id: $id)
} 